var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "19px",
    viewBox: "0 0 29 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "behance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.529412 0 0 0 0 0.533333 0 0 0 0 0.545098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-page",
    transform: "translate(-1028.000000, -374.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Socail",
    transform: "translate(931.000000, 170.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(97.000000, 4.100000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "behance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5646635,8.06535586 C13.14982,7.30767101 13.9772916,6.16117419 13.9772916,4.37662697 C13.9772916,0.857380227 11.3553032,0 8.3295486,0 L0,0 L0,17.6660205 L8.56383273,17.6660205 C11.7740238,17.6660205 14.7898089,16.1257269 14.7898089,12.5366934 C14.7898089,10.3184713 13.7380227,8.67848241 11.5646635,8.06535586 L11.5646635,8.06535586 Z M3.88313487,3.0157851 L7.52700083,3.0157851 C8.92772085,3.0157851 10.1888673,3.40958183 10.1888673,5.03461645 C10.1888673,6.53503185 9.2068679,7.13818887 7.82110219,7.13818887 L3.88313487,7.13818887 L3.88313487,3.0157851 L3.88313487,3.0157851 Z M8.03544724,14.6651897 L3.88313487,14.6651897 L3.88313487,9.80005539 L8.11520354,9.80005539 C9.82497923,9.80005539 10.9066741,10.5128773 10.9066741,12.3223484 C10.9066741,14.1068956 9.61561894,14.6651897 8.03544724,14.6651897 L8.03544724,14.6651897 Z M25.9058433,2.66685129 L18.7427305,2.66685129 L18.7427305,0.92716699 L25.9058433,0.92716699 L25.9058433,2.66685129 L25.9058433,2.66685129 Z M28.7122681,11.4549986 C28.7122681,7.67155912 26.4990307,4.5162005 22.4862919,4.5162005 C18.5882027,4.5162005 15.9412905,7.44724453 15.9412905,11.2855165 C15.9412905,15.2683467 18.4486292,18 22.4862919,18 C25.5419551,18 27.5209083,16.6242038 28.4729992,13.6981446 L25.372473,13.6981446 C25.0384935,14.7898089 23.6626973,15.3680421 22.5959568,15.3680421 C20.5372473,15.3680421 19.4555525,14.1617281 19.4555525,12.1129881 L28.6823595,12.1129881 C28.6973138,11.9036278 28.7122681,11.6793132 28.7122681,11.4549986 Z M19.4605372,9.89975076 C19.5751869,8.21988369 20.6917751,7.16809748 22.376627,7.16809748 C24.1412351,7.16809748 25.028524,8.20492938 25.178067,9.89975076 L19.4605372,9.89975076 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.370b8b110bc5b380873d5eeb18d81b06.svg";
export { ForwardRef as ReactComponent };